// ======================================================
// ProductDetails.jsx – Product setup with reference image
// ======================================================

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../assets/styles/ProductDetails.module.css";
import axios from "axios";

function ProductDetails() {
  const navigate = useNavigate();
  const username = localStorage.getItem("username");
  const password = localStorage.getItem("password");

  const [productName, setProductName] = useState("");
  const [numForms, setNumForms] = useState(1);
  const [prompt, setPrompt] = useState(""); // freeform prompt
  const [refImage, setRefImage] = useState(null);
  const [refImagePath, setRefImagePath] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [imageGenUrl, setImageGenUrl] = useState(
    localStorage.getItem("IMAGE_GEN_URL") || ""
  );

  useEffect(() => {
    localStorage.setItem("IMAGE_GEN_URL", imageGenUrl);
  }, [imageGenUrl]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && ["image/png", "image/jpg", "image/jpeg"].includes(file.type)) {
      setRefImage(file);
      setRefImagePath(file.name);
    } else {
      setRefImage(null);
      setRefImagePath("");
      alert("Please select a PNG or JPG or JPEG file.");
    }
  };

  const handleGenerateForm = async () => {
    if (!username || !password) {
      alert("Username/password missing – please log in again.");
      navigate("/");
      return;
    }
    if (!productName.trim()) {
      alert("Please enter a product name.");
      return;
    }
    if (!prompt.trim()) {
      alert("Please enter a prompt.");
      return;
    }
    if (!refImage) {
      alert("Please upload a reference image.");
      return;
    }
    if (!imageGenUrl.trim()) {
      alert("Please enter IMAGE_GEN_URL.");
      return;
    }

    const productFolder = productName.toLowerCase().replace(/\s+/g, "");
    setIsGenerating(true);

    try {
      // authenticate user first
      await axios.post("http://localhost:5000/api/auth/start", {
        username,
        password,
      });

      // for each form, upload the image and data using FormData
      for (let i = 0; i < numForms; i += 1) {
        const formData = new FormData();
        formData.append("username", username);
        formData.append("productName", productFolder);
        formData.append("seed", 42 + i);
        formData.append("prompt", prompt);
        formData.append("imageGenUrl", imageGenUrl);
        formData.append("referenceImage", refImage);

        await axios.post(
          "http://localhost:5000/api/generate/upload",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      }

      localStorage.setItem("productName", productFolder);
      navigate("/form-display");
    } catch (err) {
      console.error(err);
      alert(
        err.response
          ? `Backend error ${err.response.status}: ${err.response.data.message}`
          : "Unexpected error during generation."
      );
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2>Enter Product Details</h2>

      {/* Product Name */}
      <label>Product Name</label>
      <input
        value={productName}
        onChange={(e) => setProductName(e.target.value)}
        placeholder="e.g. Aerodynamic Car"
      />

      {/* Number of Forms */}
      <label>Number of Forms: {numForms}</label>
      <div className={styles.stepper}>
        <button
          disabled={numForms <= 1}
          onClick={() => setNumForms(numForms - 1)}
        >
          –
        </button>
        <span>{numForms}</span>
        <button
          disabled={numForms >= 10}
          onClick={() => setNumForms(numForms + 1)}
        >
          +
        </button>
      </div>

      {/* IMAGE_GEN_URL */}
      <label>IMAGE_GEN_URL</label>
      <input
        value={imageGenUrl}
        onChange={(e) => setImageGenUrl(e.target.value)}
        placeholder="https://xxxxx.ngrok-free.app/generate"
      />

      {/* Prompt */}
      <label>Prompt for Generation</label>
      <input
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder="e.g. Generate product concept rendering of a car made of plastic based on reference image"
      />

      {/* Reference Image Upload */}
      <label>Reference Image (PNG, JPG, JPEG)</label>
      <input
        type="file"
        accept=".png,.jpg,.jpeg"
        onChange={handleImageChange}
        className={styles.fileInput}
      />
      {refImagePath && (
        <div className={styles.filePath}>Selected: {refImagePath}</div>
      )}

      <button
        className={styles.generateBtn}
        onClick={handleGenerateForm}
        disabled={isGenerating}
      >
        {isGenerating ? "Generating…" : "Generate Form"}
      </button>
    </div>
  );
}

export default ProductDetails;
